import React, {useContext, useRef, useState} from "react";
import {LayoutContext} from "../../../../../../layout/context/LayoutContext";
import {Toast} from "primereact/toast";
import {usePagination} from "../../../../../../layout/hooks/usePagination";
import {useFetch} from "../../../../../../layout/hooks/useFetch";
import {webInfo} from "../../../../../../utils/webInfo";
import callToast, {handleChangeData, postData, validateFormFields} from "../../../../../../utils/helper";
import {Button} from "primereact/button";
import PageHeading from "../../../../../../Components/PageHeading";
import {DataTable, DataTableRowToggleEvent} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dialog} from "primereact/dialog";
import Label from "../../../../../../Components/Label";
import {InputText} from "primereact/inputtext";
import {InputTextarea} from "primereact/inputtextarea";

interface InitialState {
    name: string,
    short_description?: string,
}
const VehicleType = () => {
    const initialState: InitialState = {
        name: '',
        short_description: ''
    };
    const {accessToken} = useContext(LayoutContext)
    const [refresh, setRefresh] = useState<boolean>(false);
    const [formData, setFormData] = useState<InitialState>(initialState);
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const toast = useRef<Toast | null>(null)


    const [expandedRows, setExpandedRows] = useState<any | undefined>(undefined);

    const [modal, setModal] = useState<boolean>(false);
    const [updatedId, setUpdatedId] = useState<number | null>(null);

    // pagination
    const {page, limitData, handlePageChange} = usePagination();

    // endpoint
    const mainTitle = "Vehicle Types"
    const tableDataEndpointUrl = `/vehicle-types?page=${page} `
    const submitFormEndpointUrl = updatedId ? `/vehicle-types/${updatedId}` : "/vehicle-types";

    // fetch data
    const {
        data: tableDataList,
        totalData, loading
    } = useFetch(tableDataEndpointUrl, [refresh])

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validationRules = [
            { field: 'name', label: 'Name' },
        ];

        if (!validateFormFields(formData, validationRules, toast)) return;

        const payload = {
                name: formData.name.replace(/\s+/g, ' ').trim(),
                short_description: formData?.short_description?.replace(/\s+/g, ' ').trim()
            };

        try {
            const response = await fetch(`${webInfo?.baseUrl}${submitFormEndpointUrl}`, postData('PUT',accessToken,payload));

            if (response.ok) {
                setIsSubmitting(true);
                callToast(toast, true, `${mainTitle} ${updatedId ? 'updated' : 'created'} successfully`);
                setFormData(initialState)
                setModal(false)
                setUpdatedId(null)
                setRefresh(!refresh);
                return;
            }else{
                const resData = await response.json();
                callToast(toast, false, resData.error);
            }

        } catch (err) {
            console.error('Failed to update', err);
        }finally {
            setIsSubmitting(false);
        }

    }

    // row edit template
    const actionTemplate = (rowData: any) => {
        return (
            <div className={'flex align-items-center justify-content-end'}>
                <Button icon={'pi pi-pencil'} className={'border-rounded w-2rem h-2rem'} onClick={() => {
                    setModal(true)
                    setUpdatedId(rowData?.id)
                    setFormData({name: rowData.name, short_description: rowData.short_description});

                }} outlined/>
            </div>
        )
    }


    // expandable templates start
    const allowExpansion = (rowData: any) => {
        return rowData?.short_description?.length > 0;
    };

    const rowExpansionTemplate = (data: any) => {

        return (
            <div className="p-4  rounded-md shadow-sm">
                <h6 className="text-lg font-semibold mb-2 text-gray-700 flex items-center gap-2">
                    Description
                </h6>
                <p className="text-gray-600 text-base">{data.short_description}</p>
            </div>
        );
    };
    // expandable templates end
    return (
        <div className={"card"}>
            <Toast ref={toast}/>
            <PageHeading title={mainTitle}
                         isCreate={true}
                         createFunction={() => setModal(true)}
                         back={true}
            />

            <DataTable
                value={tableDataList}
                dataKey="id"
                tableStyle={{minWidth: '50rem'}}
                paginator={tableDataList?.length > 0}
                lazy
                first={(page - 1) * limitData}
                rows={limitData}
                totalRecords={totalData}
                loading={loading}
                onPage={handlePageChange}

                expandedRows={expandedRows}
                onRowToggle={(e: DataTableRowToggleEvent) => setExpandedRows(e?.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column expander={allowExpansion} style={{width: '3rem'}}/>
                <Column
                    field="name"
                    header="Name"
                    style={{width: '50%'}}
                    headerClassName={"white-space-nowrap"}/>
                <Column header={"Action"} rowEditor={true}
                        bodyStyle={{textAlign: 'center'}}
                        body={actionTemplate}
                        headerClassName={"flex justify-content-end"}
                />
            </DataTable>

            <Dialog visible={modal}
                    style={{width: "50rem"}}
                    headerClassName="text-800 font-semibold text-xl"
                    header={updatedId ? `Edit ${mainTitle}` : `New ${mainTitle}`}
                    breakpoints={{"960px": "75vw", "640px": "90vw"}}
                    onHide={() => {
                        setUpdatedId(null)
                        setModal(false)
                        setFormData(initialState)
                    }}
            >
                <div>
                    <form className={''}
                          onSubmit={handleSubmit}
                    >
                        <div className="grid ">
                            <div className="col-12 md:col-8">
                                <Label label={"Name"} required={!updatedId}/>
                                <InputText
                                    id="name"
                                    value={formData.name}
                                    size={100}
                                    name={"name"}
                                    onChange={(e) => handleChangeData('name', e.target.value, formData, setFormData)}
                                    placeholder={"Enter name"}
                                    className={`w-full`}

                                />
                            </div>
                        </div>

                        <div className="grid md:pt-2">
                            <div className="col-12 ">
                                <Label label={"Description"}/>
                                <InputTextarea
                                    id="description"
                                    value={formData.short_description}
                                    name={"description"}
                                    className={`w-full`}
                                    onChange={(e) => handleChangeData('short_description', e.target.value, formData, setFormData)}
                                    placeholder={"Enter description"}
                                />
                            </div>
                        </div>
                        <div className="flex gap-2 mt-2">
                            <Button
                                type="submit"
                                label={updatedId ? 'Update' : "Create"}
                                className="p-button-primary"
                                size={'small'}
                                loading={isSubmitting}
                            />
                        </div>
                    </form>
                </div>
            </Dialog>

        </div>
    );
};

export default VehicleType;